// PDF Faturadan Ürün Aktar penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'documents.pdfInvoiceImport';

export const pdfInvoiceImportGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'PDF faturadan ürün nasıl aktarılır?'),
  intro: t(`${G}.intro`, 'Tedarikçinizden gelen PDF faturadaki ürün satırlarını okur, stoğunuzdaki ürünlerle eşleştirir ve alış formuna kalem olarak ekler. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık'),
    body: t(`${G}.regions.body`, 'Dosya ve eşleşme sonuçları'),
    footer: t(`${G}.regions.footer`, 'Faturaya Aktar'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Bu pencere ne işe yarar?'),
      text: t(`${G}.s1.text`, 'Alış formundaki "PDF\'den Yükle" düğmesiyle açılır. Ürünleri elle tek tek girmek yerine PDF faturadaki satırları (ürün adı, miktar, birim, birim fiyat, KDV % ve iskonto) okuyup forma ekler.'),
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. PDF seçin ve analiz edin'),
      text: t(`${G}.s2.text`, '"Dosya Seç" ile PDF dosyasını seçin, ardından "PDF\'i Analiz Et"e basın. Analiz bitince "Eşleşme Sonuçları" açılır; üstte Toplam ürün, Otomatik eşleşen ve Manuel eşleştirme gereken sayılar görünür.'),
      tips: [
        t(`${G}.s2.tip1`, 'Yalnız .pdf dosyaları yüklenebilir; dosya 10 MB\'dan küçük olmalıdır.'),
        t(`${G}.s2.tip2`, 'PDF okunurken bir sorun fark edilirse sarı uyarı kutusunda listelenir.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Eşleşme güvenini okuyun'),
      text: t(`${G}.s3.text`, '"Güven" sütunu PDF\'deki ürünün stoktaki ürüne ne kadar benzediğini yüzde ile gösterir. Otomatik eşleşen satırda ✓ işaretiyle stoktaki ürünün adı ve eşleşme açıklaması yazar.'),
      tips: [
        t(`${G}.s3.tip1`, 'Yüksek (yeşil): %90 ve üzeri.'),
        t(`${G}.s3.tip2`, 'Orta (sarı): %60 ile %89 arası; aktarmadan önce doğru ürün olduğunu kontrol edin.'),
        t(`${G}.s3.tip3`, 'Düşük (kırmızı): %60\'ın altı.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Eşleşmeyenleri elle düzeltin'),
      text: t(`${G}.s4.text`, 'Eşleşmeyen ürünler turuncu çizgiyle listenin en üstünde gösterilir. "Stokta Ara" kutusuna ürün adı, stok kodu veya barkodun en az 2 karakterini yazın ve listeden doğru stok ürününü seçin. Boş bırakırsanız satır stoksuz ürün olarak eklenir.'),
      tips: [
        t(`${G}.s4.tip1`, 'Otomatik eşleşen satırlar bu pencerede değiştirilemez; yanlış eşleşmişse aktardıktan sonra formda satırı silip doğru ürünü ekleyin.'),
        t(`${G}.s4.tip2`, 'Stoksuz ürün olarak eklenen satırlar stok hareketi oluşturmaz.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s5.title`, '5. Faturaya aktarın'),
      text: t(`${G}.s5.text`, '"… Ürünü Faturaya Aktar" tüm satırları formdaki mevcut kalemlerin sonuna ekler. "İptal" hiçbir şey eklemeden kapatır.'),
      tips: [
        t(`${G}.s5.tip1`, 'Aktarılan kalemlere depo atanmaz. Stoğa girmeleri için formda her satırda depo seçin veya "Toplu Depo Seç"i kullanın.'),
        t(`${G}.s5.tip2`, 'Aktarma yalnız formu doldurur; stok ve cari, faturayı kaydettiğinizde işlenir.'),
      ],
    },
  ],
});
